(() => {
  const initialize = async (root) => {
    await customElements.whenDefined('slideshow-component');
    for (const banner of root.querySelectorAll('.category-banner-slideshow[data-sph-collection-autoplay]')) {
      const slideshow = banner.querySelector('slideshow-component');
      const toggle = banner.querySelector('[data-sph-autoplay-toggle]');
      if (!slideshow || banner.dataset.sphAutoInitialized === 'true') continue;
      banner.dataset.sphAutoInitialized = 'true';
      const controller = new AbortController();
      const { signal } = controller;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const intervalMs = Number.parseInt(banner.dataset.sphCollectionAutoplay, 10) || 5000;
      let timer;
      let onScreen = false;
      let pointerDown = false;
      let userPaused = motion.matches;
      let explicitPlay = false;
      let motionOverride = false;
      let observer;

      const sync = () => {
        window.clearTimeout(timer);
        timer = undefined;
        slideshow.suspend();
        const reduced = motion.matches && !motionOverride;
        banner.dataset.sphPaused = String(userPaused || reduced);
        const label = userPaused || reduced ? toggle?.dataset.labelPlay : toggle?.dataset.labelPause;
        toggle?.setAttribute('aria-label', label);
        toggle?.setAttribute('title', label);
        const focused = banner.contains(document.activeElement) &&
          !(explicitPlay && document.activeElement === toggle);
        const hovered = hover.matches && banner.matches(':hover') && !explicitPlay;
        const blocked = !onScreen || document.hidden || reduced || userPaused ||
          pointerDown || focused || hovered;
        slideshow.setAttribute('aria-live', blocked ? 'polite' : 'off');
        if (blocked || signal.aborted) return;
        timer = window.setTimeout(() => {
          timer = undefined;
          slideshow.next();
          sync();
        }, intervalMs);
      };

      toggle?.addEventListener('click', (event) => {
        const reduced = motion.matches && !motionOverride;
        userPaused = !(userPaused || reduced);
        explicitPlay = !userPaused;
        if (explicitPlay) motionOverride = true;
        if (event.detail > 0) toggle.blur();
        sync();
      }, { signal });
      banner.addEventListener('mouseenter', () => {
        explicitPlay = false;
        sync();
      }, { signal });
      banner.addEventListener('mouseleave', sync, { signal });
      banner.addEventListener('focusin', () => {
        explicitPlay = false;
        sync();
      }, { signal });
      banner.addEventListener('focusout', () => window.requestAnimationFrame(sync), { signal });
      banner.addEventListener('pointerdown', () => {
        pointerDown = true;
        sync();
      }, { signal });
      const releasePointer = () => {
        if (!pointerDown) return;
        pointerDown = false;
        sync();
      };
      document.addEventListener('pointerup', releasePointer, { signal });
      document.addEventListener('pointercancel', releasePointer, { signal });
      slideshow.addEventListener('slideshow:select', (event) => {
        if (event.detail?.userInitiated) sync();
      }, { signal });
      document.addEventListener('visibilitychange', sync, { signal });
      motion.addEventListener('change', () => {
        motionOverride = false;
        explicitPlay = false;
        sync();
      }, { signal });
      hover.addEventListener('change', sync, { signal });
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          onScreen = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.25);
          sync();
        }, { threshold: [0, 0.25, 0.75] });
        observer.observe(banner);
      } else {
        onScreen = true;
      }
      const section = banner.closest('.shopify-section');
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target !== section) return;
        window.clearTimeout(timer);
        observer?.disconnect();
        slideshow.suspend();
        controller.abort();
        delete banner.dataset.sphAutoInitialized;
      }, { signal });
      sync();
    }
  };
  initialize(document);
  if (!window.sphCollectionBannerSectionListener) {
    window.sphCollectionBannerSectionListener = true;
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  }
})();
